// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> aion-management-comfy -> aston-pointe-apartments
// Generated: 2026-10-22T20:07:48.905Z
// Counts: 5 design, 68 content, 57 slot group, 1 collection binding, 9 section, 5 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Accessibility",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Amenities",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Apply Now",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Floor Plans",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Gallery",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 48px;\">Welcome To</span></h1><h1><span style=\"font-size: 48px;\"><span data-type=\"field-token\" data-field=\"property_name\"></span></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Interactive Map",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Neighborhood",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The heart of a growing community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Pet Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Privacy Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>A Place to Come Together .</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Schedule a Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Transparent pricing for <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Fee Information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Your pet belongs <em>here, too.</em></h3><h3></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious one and two bedroom floor plans and find your perfect landing place in Delaware County at Aston Pointe Apartments. Our pet-friendly community provides a comfortable retreat with plenty of perks plus friendly neighborhood vibes at an affordable price. Here you can enjoy a park-like setting with scenic landscapes.</p><p>Situated near major highways and employers, Aston Pointe Apartments offers a lifestyle where work and play are right outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.heading": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-form.talk_blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Tour the community from anywhere</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Aston Pointe Apartments in Aston, PA, where comfort meets convenience. Enjoy spacious one- and two-bedroom layouts surrounded by park-like landscaping, pet-friendly amenities, and modern conveniences like online rental payments. Embrace a vibrant lifestyle just minutes from I-95, with easy access to Center City Philadelphia and downtown Wilmington.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Aston Pointe Apartments in Village Green, PA, where comfort meets convenience. Choose from spacious one and two-bedroom floor plans, featuring modern amenities and pet-friendly options. With 24-hour maintenance, a playground, and serene, landscaped grounds, your new home is just a few clicks away. Lease online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aston Pointe Apartments in Aston, PA, your ideal living space awaits. Choose from our thoughtfully designed one and two-bedroom floor plans, tailored for comfort and style. Each layout offers a unique ambiance that complements your lifestyle. Browse our available apartment homes today and find your perfect fit!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aston Pointe Apartments in Aston, PA, picture your ideal home nestled in a park-like setting. Choose from spacious one- or two-bedroom floor plans, complete with modern amenities like a dog park, on-site laundry, and furnished options. Enjoy convenient access to Philadelphia and Wilmington—your dream lifestyle awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.name": {
    "overrideType": "VALUE",
    "customValue": "Aston Pointe Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy our one- and two- bedroom apartment homes for rent in Aston, Pennsylvania.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aston Pointe Apartments in Aston, PA, your new home is surrounded by vibrant community experiences. Enjoy nature at Ridley Creek State Park or Tyler Arboretum, and revel in local college life with nearby Swarthmore, Widener, and Penn State Brandywine. Dive into outdoor adventures and enriching activities just steps away!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>AION allows residents to have dogs, cats, and service animals. All animals must be housebroken, and no breeding is allowed. Certain dog breeds and mixes (e.g., German Shepherds, Akitas, Chow mixes, American Bulldogs, Staffordshire Terriers, Dobermans, Rottweilers, wolf‑dog hybrids, Pit‑bull terriers, Presa Canario, and Canary dogs) are prohibited. A Pet Addendum and photo are required. Pet fees: $300 one‑time non‑refundable fee per pet; monthly pet rent is $50 for the first pet and $25 for the second. Maximum of 2 pets per unit.</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to the Aston Pointe Apartments, where comfort meets convenience in Village Green, PA. Whether you choose a one-bedroom haven or a spacious two-bedroom retreat, our tailored floor plans elevate your living experience. Access your resident portal to manage rent and maintenance requests effortlessly—your lifestyle upgrade is just a click away!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "Download the Loft Resident Mobile App",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>At Aston Pointe Apartments in Village Green, PA, choose from spacious one- and two-bedroom floor plans tailored for your lifestyle. Experience the vibrant community that awaits you—schedule a tour today and see why our residents love calling Aston Pointe home! Your ideal apartment is just a visit away!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Thank You",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>Thank you for reaching out to Aston Pointe Apartments in Aston, PA! With thoughtfully designed one and two-bedroom floor plans, your ideal home awaits. A member of our team will be in touch shortly to help you embark on this exciting journey toward your new apartment living experience!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "residentaccess.login_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Access Resident Portal Login"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166310/019d0266-eb23-7135-a5df-bdf331df47b0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with black appliances and white cabinetry."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-b3f0-717d-9a8b-9a8f689d9bdc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Cozy bedroom featuring a bed and stacked washer-dryer unit"
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-eb23-7135-a5df-bdf331df47b0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen in apartment with white cabinets, black fridge, microwave, stove, and stainless sink."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0267-00a0-7682-bf0a-07716039531c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright white kitchen with cabinets, white appliances, sink, and tile backsplash."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-e077-7035-a5ea-f4c6259adc4b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a low-profile upholstered bed, gray bedding, wall art, rug, and a stacked washer/dryer in a closet."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-dd95-742c-ab5a-6917ae89a561.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-layout living room in a modern apartment with sofa, coffee table, and kitchen in background."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-dd53-76c8-8704-6d314fa203fb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a wooden bed, nightstand, lamp, window, and plant."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-f839-70cf-8d13-d485f418f79d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "White apartment bathroom with toilet, sink vanity, wall cabinet, and bathtub/shower."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166310/019d0266-4a2b-773f-8572-62daa16286b4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings surrounded by suburban neighborhood and lush green trees."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-4a2b-773f-8572-62daa16286b4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a residential community with houses and green spaces."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0267-0326-71bd-a407-c32babd1af22.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior sign for Aston Pointe Apartments with landscaping and brick buildings in the background."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0267-04e0-721b-9b56-7cf832fc56d2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a two-story brick apartment building with a green lawn and walkway."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166310/019fde6b-bb2a-7168-8b5e-754ff3842543.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered picnic pavilion with grills and picnic tables next to a playground."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0267-04dd-71a7-ac91-1174faedfa1c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced dog park with agility equipment"
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-ced4-71b7-a3a0-74e381604e10.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wooden pavilion with picnic tables and a grill in a grassy area; playground visible nearby."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-cf96-73e0-8629-ae1ebf76d22d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright red multi-playground structure with slides on mulch."
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pest": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pest Control"
      },
      "amount": {
        "type": "VALUE",
        "customValue": ""
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Covers up to 2 pets."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500–$1000"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-f6d3-72b9-a8aa-bdf860c1e5c2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a gray sofa, white media console, plants, and a large window with sheer curtains."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-eb23-7135-a5df-bdf331df47b0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen in apartment with white cabinets, black fridge, microwave, stove, and stainless sink."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-ced4-71b7-a3a0-74e381604e10.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wooden pavilion with picnic tables and a grill in a grassy area; playground visible nearby."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-ec31-7084-804b-f21987a64ffe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a neatly made bed, nightstands, lamps, dresser, and abstract artwork on the wall."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-8830-7319-a3d7-95b797ae5dcc.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Taste Budz Cafe"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Breakfast"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.4"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual eatery serving breakfast dishes such as omelets and pancakes plus dinner."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-a319-701a-94a7-0040400c0741.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "GIANT"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.2"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Grocery chain offering everyday items, plus premium beer and wine selections, and fresh sushi."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-e6ad-7728-95ee-4dabf611d524.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Ridley Creek State Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Outdoors"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Green oasis of woodlands & meadows offering hiking, fishing & picnicking from sunrise to sunset."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-879e-7659-8449-b8c3e6002b60.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Aston Diner"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dining & Brunch"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.3"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "All-hours diner offering traditional American grub, including breakfast, in an easygoing atmosphere."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-cd04-77fe-986f-c400a3e2bc47.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Brandywine Museum of Art"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "10.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Gristmill-turned-museum with paintings by Howard Pyle, N.C. Wyeth & others plus big windows & views."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-e59d-77ba-ab3d-bd331ffdce05.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Chester Creek Trail"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Flat paved trail taking in views of the surrounding nature as well as the occasional road crossing."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-9041-7640-a06c-dc2d608c025d.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Applebee's Grill + Bar"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Grill"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.8"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Full-service chain bar & grill providing hearty American eats in an informal setting."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-9311-726a-9bfe-a32015ab4c06.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Barnaby's Restaurant & Pub"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Pub & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.4"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Pub & grill offering craft beers, burgers & sandwiches in a laid-back space with patio seating."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-89a8-7697-aaed-826fd9addd99.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Gennaro's Italian Kitchen"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dinner & Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.6"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Low-key locale serving familiar Italian dishes such as veal marsala & pasta with a choice of sauce."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-900e-73a9-950b-ac67eb1d344b.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Phoenix Bar & Grill Aston"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Lounge"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.3"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Neighborhood bar and grill pouring drinks and serving casual fare for a relaxed night out close to home."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-c2ac-76da-a275-4e988668eeba.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Regal Brandywine Town Center"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "9.0"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Theater complex with multiple screens featuring new release films, plush seating & concession stand."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-9d46-713a-ab7d-03a62a2e590c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Tom's Pizza Place"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Late-Night Eats"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.7"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual venue serving pizza, wings, and other comfort food, with late-night hours."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-bd6a-732a-ae67-586093546f57.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fully furnished bedroom with a large bed, dresser, and bedside tables."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-d2b1-72d7-9753-6bc6cde86077.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Brick apartment buildings with white trim and green lawns."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-dc1f-72ba-8655-ed652eb0efe7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground equipment with slides and bars, surrounded by trees and buildings."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "homegallerypreview.photos": {
    "limit": 4,
    "hiddenIds": null,
    "orderedIds": [
      "custom_53c65c11-b881-4203-96ae-64ab3b7a33c1",
      "custom_300e8054-94ac-461b-876c-608f3fdbc96c",
      "custom_0dc93c65-02f8-4297-89e5-5ad1cf785d86",
      "custom_2cf2a90e-babf-4024-9f53-2dba5e8e1c4d",
      "custom_2a930c1f-1a69-4e2f-aa26-34e756ebaf72",
      "custom_4ac14e66-f379-447c-b168-c927ec101526",
      "custom_33cf880d-c3c9-4635-a0f2-a4f01e3006a9",
      "custom_da1de87e-080e-4ef6-8923-afdf68377bde",
      "custom_115e7b30-8ca1-4d98-bdcb-f55bba1a71d9",
      "custom_0fa162e7-0642-43bf-b24b-7cfda1d5bb95",
      "custom_6bfa736e-51a3-4028-ae28-941c36d378d3",
      "custom_4a08ffeb-3865-471e-97ec-f2797c2db282",
      "custom_8841a124-ffe1-4de6-b446-cd0bb04ecef5",
      "custom_6c809276-44af-4acc-a56d-e64ec5bdf23e",
      "custom_baab9728-0d9b-4295-8fb6-cbc0404158c4",
      "custom_08c3424c-b045-42aa-9aee-b3abeea0e0b5",
      "custom_af7bc580-0961-421a-9dce-a2e799ca72c3",
      "custom_7fabd371-5933-4444-8381-1104cc5bc888",
      "custom_a2931cb4-fbe5-40ec-9d30-6299f99a65dc"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingBottom": "30px"
    }
  },
  "hero.name": {
    "properties": {
      "paddingBottom": "50px"
    }
  },
  "propertyoverview.blurb": {
    "properties": {
      "fontWeight": "300"
    }
  },
  "residentaccess.app_heading": {
    "properties": {
      "fontWeight": "700"
    }
  }
};
